import { render, staticRenderFns } from "./FiniceUser.vue?vue&type=template&id=6b3141f6&scoped=true"
import script from "./FiniceUser.vue?vue&type=script&lang=js"
export * from "./FiniceUser.vue?vue&type=script&lang=js"
import style0 from "./FiniceUser.vue?vue&type=style&index=0&id=6b3141f6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b3141f6",
  null
  
)

export default component.exports